import { SitesResponse, SlateResponse, SportsResponse } from "../store/types";

export const getSupportedSports = (app: string): SportsResponse[] => {
  // Late Swap only supports these sports
  if (app === 'LATESWAP') {
    return [
      { sport: 'NFL' },
      { sport: 'NBA' },
      { sport: 'MLB' },
      { sport: 'CFB' }
    ];
  }

  const baseSports: SportsResponse[] = [
    { sport: 'NFL' },
    { sport: 'NBA' },
    { sport: 'NHL' },
    { sport: 'MLB' },
    { sport: 'CFB' },
    { sport: 'PGA' },
    { sport: 'MMA' },
    { sport: 'NASCAR' },
  ];

  return baseSports;
}

export const SupportedSites: SitesResponse[] = [
  { site: 'DK' },
  { site: 'FD' },
  { site: 'YH' },
];

export const filterSlates = (slates: SlateResponse[], selectedSport: SportsResponse, selectedSite: SitesResponse, selectedType: string) => {
  return slates.filter(x => x.sport === selectedSport?.sport && x.site === selectedSite?.site && x.type === selectedType);
}